import React from "react";
import styled from "styled-components";
import { H1, SubheadLg } from "storybook-components/Typography";
import Container from "storybook-components/Container";

const HeroContent = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.green5};
  display: flex;
  align-items: center;
  padding: 40px 16px;
  justify-content: center;
  margin-bottom: -32px;
  ${({ theme }) => theme.media.tabletUp`
    padding: 32px 0 64px;
    text-align: center;
  `};
`;

const HeroBodyText = styled(SubheadLg)`
  max-width: 560px;
  color: ${({ theme }) => theme.colors.gray1};
  text-align: center;
  margin: auto;
`;

const StyledH1 = styled(H1)`
  color: ${({ theme }) => theme.colors.gray1};
  text-align: center;
  margin-bottom: 24px;
`;

const HubHero = () => {
  return (
    <HeroContent>
      <Container>
        <StyledH1>Resources</StyledH1>
        <HeroBodyText>
          Explore our data analytics resources, curated to help you take your
          skills to the next level.
        </HeroBodyText>
      </Container>
    </HeroContent>
  );
};

export default HubHero;
